<lib-modal
  data-testid="defect-dialog"
  [title]="'defect.capture.title' | translate"
  [text]="'defect.capture.subtitle' | translate"
  [contentTemplate]="formTemplate"
  [visible]="open()"
  [disabled]="!canSubmit()"
  [saveText]="(submitting() ? 'defect.capture.submitting' : 'defect.capture.submit') | translate"
  [cancelText]="'defect.capture.cancel' | translate"
  (save)="submit()"
  (cancel)="cancel()"
></lib-modal>

<ng-template #formTemplate>
  <form class="defect-dialog" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'defect.capture.titleLabel' | translate }}</mat-label>
      <input
        matInput
        formControlName="title"
        required
        data-testid="defect-title"
        [attr.maxlength]="fieldLengths.NAME_MAX"
      />
    </mat-form-field>

    <div class="defect-dialog__severity">
      <span class="defect-dialog__label" aria-hidden="true">{{ 'defect.capture.severityLabel' | translate }}</span>
      <mat-button-toggle-group
        formControlName="severity"
        [attr.aria-label]="'defect.capture.severityLabel' | translate"
      >
        @for (severity of severities; track severity) {
          <mat-button-toggle [value]="severity" [attr.data-testid]="'defect-severity-' + severity">
            {{ 'defect.capture.severity.' + severity | translate }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'defect.capture.descriptionLabel' | translate }}</mat-label>
      <textarea
        matInput
        rows="4"
        formControlName="description"
        data-testid="defect-description"
        [attr.maxlength]="fieldLengths.FREETEXT_MAX"
      ></textarea>
      <mat-hint>{{ 'defect.capture.descriptionHint' | translate }}</mat-hint>
      <mat-hint align="end" aria-live="polite">{{ descriptionLength() }} / {{ fieldLengths.FREETEXT_MAX }}</mat-hint>
    </mat-form-field>

    <app-person-select
      class="tc-field"
      formControlName="assigneeUserId"
      data-testid="defect-assignee"
      noneKey="defect.capture.noAssignee"
      [label]="'defect.capture.assigneeLabel' | translate"
      [options]="personOptions()"
      [allowNone]="true"
    />

    @if (errorKey(); as key) {
      <p class="defect-dialog__error" role="alert" data-testid="defect-error">{{ key | translate }}</p>
    }
  </form>
</ng-template>
